// BUILD-046 Owner direction 2026-10-24: Edit task gives clear access to the EXISTING Reassign and Add recipients operations. Those operations live in the row (their pickers, confirmations and outcomes are the
// row's own: TaskActionControls for Reassign, the Everyone request's issuer actions for Add recipients). The Edit form asks for one through this tiny store; the row that owns the task or the request opens
// its own flow, exactly as if its menu entry had been chosen, and only if the existing rules offer it to this person. Nothing is sent from here and nothing is decided here.
import { useSyncExternalStore } from 'react';

export type AssignmentControl = 'reassign' | 'add-recipient';

export interface AssignmentRequest {
  /** The task id (Reassign) or the request id (Add recipient) the row owns. */
  id: string;
  control: AssignmentControl;
  /** Grows with every request, so asking twice opens twice. */
  nonce: number;
}

let last: AssignmentRequest | null = null;
const listeners = new Set<() => void>();

export const assignmentActions = {
  request(id: string, control: AssignmentControl): void {
    last = { id, control, nonce: (last === null ? 0 : last.nonce) + 1 };
    for (const listener of [...listeners]) listener();
  },
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  get(): AssignmentRequest | null {
    return last;
  },
};

/** The latest request addressed to `id`, or null (a request for another row is not this row's). */
export function useAssignmentRequest(id: string): AssignmentRequest | null {
  const current = useSyncExternalStore(assignmentActions.subscribe, assignmentActions.get);
  return current !== null && current.id === id ? current : null;
}
